import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { horizontalLoop } from './horizontalLoop';

// Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Navigation]);

// GSAP
window.gsap = gsap;
gsap.registerPlugin(SplitText, ScrollTrigger);
window.SplitText = SplitText;
window.ScrollTrigger = ScrollTrigger;
// window.horizontalLoop = horizontalLoop;

// Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();
